import { createContext, RefObject, useContext } from "react";

export type MenuContextValue = {
  open: boolean;
  toggle: () => void;
  close: () => void;
  triggerRef: RefObject<HTMLElement>;
  menuRef: RefObject<HTMLDivElement>;
};

export const MenuContext = createContext<MenuContextValue | null>(null);

export function useMenuContext(): MenuContextValue {
  const ctx = useContext(MenuContext);
  if (!ctx) {
    throw new Error(
      "Menu compound components (Menu.Trigger, Menu.Items, Menu.Item) must be rendered inside <Menu>"
    );
  }
  return ctx;
}
